/*
 * @Author: Cphayim
 * @Date: 2019-09-29 13:59:27
 * @LastEditTime: 2022-03-25 16:55:26
 * @Description: 指令入口
 */

export const registerDirectives = Vue => {
  // 这里注册你的全局指令
  // 防抖
  // 实例v-debounce:[arg]="[fn, event, arg]"
  Vue.directive('debounce', function(el, binding, vnode) {
    let timer = null
    const { delay = 500, immediate } = binding.arg || {}
    const [fn, event = 'click', ...arg] = binding.value
    el.addEventListener(event, () => {
      if (timer) clearTimeout(timer)
      if (immediate) {
        // 如果已经执行过，不再执行
        var callNow = !timer
        timer = setTimeout(() => {
          timer = null
        }, delay)
        if (callNow) {
          fn(...arg)
        }
      } else {
        timer = setTimeout(() => {
          fn(...arg)
        }, delay)
      }
    })
  },)
}
